import PropTypes from "prop-types";
import React, { useState } from "react";

import {
  DialogAvatar,
  DialogContent,
  DialogInlineTitle,
  DonationDialog as UIDonationDialog,
  MiniDivider,
  Person,
  Typography
} from "@theconversation/ui";

function DonationDialog({ title, body, person, donateText, onClick, onClose }) {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <UIDonationDialog
      donateText={donateText}
      onClick={onClick}
      onClose={handleClose}
      open={open}
    >
      <DialogAvatar src={person.avatar} />
      <DialogInlineTitle>{title}</DialogInlineTitle>
      <DialogContent>
        <Typography variant="subtitle1">{body}</Typography>
        <MiniDivider />
        <Person name={person.name} caption={person.caption} />
      </DialogContent>
    </UIDonationDialog>
  );
}

DonationDialog.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  person: PropTypes.shape({
    avatar: PropTypes.string,
    caption: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  donateText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DonationDialog;
